import type { TokenModel } from "../../types/authentication";
import { httpClient } from "./httpClient";

export const exchangeImpersonateToken = async (token: string): Promise<TokenModel> => {
    if (!token) {
        throw new Error("Impersonation token is required");
    }

    return httpClient.post<TokenModel>("/rest/admin/impersonate/exchange", { token }, { auth: false });
};
